export default "__VITE_ASSET__424b1ecc__"